var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PopupMenu,{attrs:{"items":_setup.menuItems,"horizontalPosition":"left"},scopedSlots:_vm._u([{key:"menuOpener",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }